import { updateUndoRedoControls } from '~core';
import { getState, modifyState, decrementState } from '~src/state';
import { convertTextboxesToSpellCheck } from '~core/spellcheck';
import checkSpellingDebounced from '~core/spellcheck/checkSpellingDebounced';

export const editorUndo = () => {
  const currentPageIndex = getState('currentPageIndex');
  const currentHistoryIndex = getState(
    `currentHistoryIndex[${currentPageIndex}]`
  );
  const history = getState(`history[${currentPageIndex}]`, []);

  if (history.length <= 0 || currentHistoryIndex <= 0) {
    console.error('Cannot undo! There is no a prev step');
    return false;
  }

  modifyState('undoInProgress', true);
  decrementState(`currentHistoryIndex[${currentPageIndex}]`);

  const previousState = history[currentHistoryIndex - 1];

  window.canvas.loadFromJSON(previousState, async () => {
    modifyState('undoInProgress', false);
    window.canvas.renderAll();
    await convertTextboxesToSpellCheck(window.canvas);
    updateUndoRedoControls();

    // Use debounced spellcheck to avoid excessive checking during rapid undo/redo
    checkSpellingDebounced(window.canvas);
  });
};
